<template>
  <div>
    <HeaderBar :title="hTitle" />
    <div
      v-for="(item, i) in items"
      :key="i"
      class="my-2 text-xl text-justify border-b border-gray-300 pb-10"
    >
      {{ item.content }}
    </div>
  </div>
</template>
<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  props: ["hTitle"],
  components: { HeaderBar },
  data() {
    return {
      items: [
        {
          id: 1,
          content:
            "During the reservation of your purchased property, you have signed your chosen and approved down payment terms. Your down payment has no interest.",
        },
        {
          id: 2,
          content:
            "The down payment will automatically start 30 days after your reservation date unless with an approved request stating otherwise. ",
        },
      ],
    };
  },
};
</script>
